import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { theme } from 'theme/theme';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  titulo: string;
  mensaje: string;
}

const Modal = ({ open, onClose, titulo, mensaje }: ModalProps) => {
  const titleId = 'modal-dialog-title';
  return (
    <Dialog maxWidth="xs" open={open} aria-labelledby={titleId}>
      <DialogTitle id={titleId} color={theme.palette.secondary.dark}>{titulo}</DialogTitle>
      <DialogContent>
        <DialogContentText>{mensaje}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color={'primary'} onClick={onClose}>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
